module.exports = __webpack_public_path__ + "static/media/notification-dashboard-notes.60987f72.svg";